<template>
  <v-app>
    <div v-if="this.$store.getters.loggedIn">
      <app-header />
      <app-admin-name />
      <div class="container">
        <router-view />
      </div>
      <app-footer />
    </div>

    <div v-else>
      <router-view />
   </div>

    <!-- app-footer / -->
  </v-app>
</template>

<script>

import axios from 'axios';

// import views from ./components/shared
import Header from './components/shared/Header.vue';
import Footer from './components//shared/Footer.vue';
import AdminName from './components/shared/AdminName.vue';


export default {
    // register local components
    components: {
      'app-header': Header,
      'app-footer': Footer,
      'app-admin-name': AdminName
    },
    data () {
      return {
        ROOT_API: null,
      }
    },

    methods: {
      checkAPIurl() {
            if (process.env.NODE_ENV === "development") {
                this.$store.dispatch('retriveDevAPIURL')
                var devURL = this.$store.getters.rootAPI
            } else {
                console.log('production')
                this.$store.dispatch('retriveProdAPIURL')
                .catch(error => {
                    console.log(error)
                })
            }
        }
    },

    mounted() {
      this.checkAPIurl();
    }
}
</script>

<!--style src="./assets/css/clockit.css"></style -->





// WEBPACK FOOTER //
// src/App.vue